import { render, staticRenderFns } from "./Smenus.vue?vue&type=template&id=2c58013c&scoped=true"
import script from "./Smenus.vue?vue&type=script&lang=js"
export * from "./Smenus.vue?vue&type=script&lang=js"
import style0 from "./Smenus.vue?vue&type=style&index=0&id=2c58013c&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58013c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c58013c')) {
      api.createRecord('2c58013c', component.options)
    } else {
      api.reload('2c58013c', component.options)
    }
    module.hot.accept("./Smenus.vue?vue&type=template&id=2c58013c&scoped=true", function () {
      api.rerender('2c58013c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/menus/Smenus.vue"
export default component.exports